export enum KlaviyoSources {
  SITE_FOOTER = "Site Footer",
  CHECKOUT_SIGNUP_FORM = "Checkout Sign Up Form",
  SIGNUP_FORM = "Sign Up Form",
  NEWSLETTER_MODAL = "Newsletter Modal",
  NEWSLETTER_MODAL_DISCOUNT = "Newsletter Modal Discount",
}
